require('./home.css')

// 处理原静态页面 <img>，替换为构建后图像地址

const images = {
  '1.png': require('./images/1.png'),
  '2.png': require('./images/2.png'),
  '3.png': require('./images/3.png'),
  '1-1.png': require('./images/1-1.png'),
  '1-2.png': require('./images/1-2.png'),
  '1-3.png': require('./images/1-3.png'),
  '2-2-new.png': require('./images/2-2-new.png'),
  // GIF 图像避免缓存，否则动画显示有问题
  'rocket.gif': require('./images/rocket.gif') + '?t=' + (new Date()).valueOf(),
  '3-1.png': require('./images/3-1.png'),
  '3-2.png': require('./images/3-2.png'),
  '3-3.png': require('./images/3-3.png'),
  '3-4.png': require('./images/3-4.png')
}

const pageQueryParams = parseUrlParams(location.search)

// mock 本地开发时的 ga()
const ga = window.ga || ((...args) => console.log(...args)) // eslint-disable-line no-console

replaceImgSrc()

gaPage()
gaEvent('from', pageQueryParams.from || 'N/A') // 埋点：页面来源

document.getElementById('and').onclick = () => gaEvent('click', '安卓下载')
document.getElementById('app').onclick = () => gaEvent('click', 'ios下载')

if (!supportCss3('animation')) {
  document.body.setAttribute('id', 'root')
} else {
  var sidebar = document.getElementsByClassName('sidebar')[0]
  var second = document.getElementsByClassName('second')[0]
  var third = document.getElementsByClassName('third')[0]
  var forth = document.getElementsByClassName('forth')[0]
  var icon = document.getElementsByClassName('icon')

  window.addEventListener('scroll', function () {
    if (getScrollTop() >= 754) {
      sidebar.style.display = 'block'
    } else {
      sidebar.style.display = 'none'
    }
    if (isElementInViewport(second)) {
      addClass(second, 'animation')
    }
    if (isElementInViewport(third)) {
      addClass(third, 'animation')
    }
    if (isElementInViewport(forth)) {
      for (var i = 0; i < icon.length; i++) {
        (function (i) {
          setTimeout(function () {
            addClass(icon[i], 'shake')
          }, (i + 1) * 1000)
        })(i)
      }
      addClass(forth, 'animation')
    }
  })
}

function replaceImgSrc() {
  const imgs = [].slice.call(document.getElementsByClassName('img-placeholder'), 0)
  for (let i = 0, len = imgs.length; i < len; i++) {
    let el = imgs[i]
    let newImg = document.createElement('img')
    newImg.src = images[el.getAttribute('src')]
    newImg.className = el.getAttribute('class-img') || ''
    newImg.style = el.getAttribute('style-img') || ''
    el.parentElement.insertBefore(newImg, el)
    el.parentElement.removeChild(el)
  }
}

function supportCss3(style) {
  var prefix = ['webkit', 'Moz', 'ms', 'o'],
    i,
    humpString = [],
    htmlStyle = document.documentElement.style,
    _toHumb = function (string) {
      return string.replace(/-(\w)/g, function ($0, $1) {
        return $1.toUpperCase()
      })
    }

  for (i in prefix)
    humpString.push(_toHumb(prefix[i] + '-' + style))

  humpString.push(_toHumb(style))

  for (i in humpString)
    if (humpString[i] in htmlStyle) return true

  return false
}

function getScrollTop() {
  var scrollTop = 0
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop
  } else if (document.body) {
    scrollTop = document.body.scrollTop
  }
  return scrollTop
}
function isElementInViewport(el) {
  var rect = el.getBoundingClientRect()
  return (
    rect.bottom >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) - 200
  )
}
function hasClass(el, className) {
  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
  return reg.test(el.className)
}

function addClass(el, className) {
  if (hasClass(el, className)) {
    return
  }
  var newClass = el.className.split(' ')
  newClass.push(className)
  el.className = newClass.join(' ')
}

function gaPage() {
  ga('send', 'pageview', 'PC_Home')
}

function gaEvent(action, label) {
  ga('send', 'event', 'PC_Home', action, label)
}

function parseUrlParams(urlSearch) {
  if (!(typeof urlSearch === 'string') || urlSearch === '') return {}
  if (urlSearch[0] === '?') urlSearch = urlSearch.slice(1)
  var parts = urlSearch.split('&')
  var params = {}
  var i = 0
  var len = parts.length
  var part
  while (i < len) {
    part = parts[i++]
    let j = part.indexOf('=')
    if (j > 0) {
      let k = decodeURIComponent(part.substr(0, j))
      let v = decodeURIComponent(part.substr(j + 1))
      params[k] = v
    } else {
      let k = decodeURIComponent(part)
      params[k] = true
    }
  }
  return params
}


// WEBPACK FOOTER //
// ./src/module/home/index.js